import React, { Component } from "react";
import Service from "../../../Service/Service";
import SiftingLogo from "../../../Graphics/SiftingLogo";
import screen from "../../../../../media/reduced-images/screen.jpg";

class Screening extends Component {
  render() {
    return (
      <Service
        logo={<SiftingLogo />}
        image={screen}
        title="Screening"
        description="We offer screening as a stand-alone service or
         incorporated with our pulverizing or blending services.  Our
          basic service separates your material into a coarse and fine
           product. Our specialty is multi grade separations.  Multi
            grade separation is a key step in abrasive and solid surface
             manufacturing. Currently we offer up to 4 grades of final product
              from a single feedstock. Our screen stock ranges from 4 mesh to 200 mesh"
      />
    );
  }
}

export default Screening;
